const API_URL = import.meta.env.VITE_API_URL
/** The public booking website (plethore-webapp-frontend), no trailing slash. */
export const WEB_BOOKING_URL = (
  import.meta.env.VITE_WEB_BOOKING_URL ?? ''
).replace(/\/$/, '')
export const BUSINESS_URL = `${API_URL}/business`

export const CSRF_COOKE_URL = `${API_URL}/auth/csrf-cookie`
export const EMAIL_RESEND_URL = `${API_URL}/auth/email/resend`
export const EMAIL_VERIFY_URL = `${API_URL}/auth/email/verify`
export const FORGOT_PASSWORD_URL = `${API_URL}/auth/forgot-password`
export const GET_LOGGED_USER_INFOS = `${API_URL}/auth/me`
export const TWO_FACTOR_AUTHENTICATIONS_URL = `${API_URL}/auth/me/2fa`
export const LOGIN_URL = `${API_URL}/auth/login`
export const LOGOUT_URL = `${API_URL}/auth/logout`
export const REGISTER_URL = `${API_URL}/auth/register`
export const RESET_PASSWORD_URL = `${API_URL}/auth/reset-password`
export const IDENTITY_VERIFICATION_GLEAP_URL = `${API_URL}/auth/identity-verification/gleap`

export const VENUE_COLLECTIONS_URL = `${API_URL}/venue-collections`
export const SEVENROOMS_URL = `${API_URL}/sevenrooms`
export const FEATURED_VENUES_URL = `${API_URL}/marketing/featured-venues`
export const FEATURED_VENUES_LIVE_URL = `${FEATURED_VENUES_URL}/live`
export const CLUSTERS_URL = `${API_URL}/clusters`
export const VENUE_SEATING_AREAS_URL = `${API_URL}/venue-seating-areas`
export const VENUE_TAGS_URL = `${API_URL}/venue-tags`
export const VENUES_URL = `${API_URL}/venues`
export const VENUE_TYPES_URL = `${API_URL}/venue-types`
export const VENUE_BILLING_URL = `${API_URL}/venue-billing`
export const VENUE_BILLING_VENUES_EXPORT_URL = `${VENUE_BILLING_URL}/venues/export`
export const SEATING_AREAS_URL = `${API_URL}/seating-areas`
export const USERS_URL = `${API_URL}/users`
export const ADMINS_URL = `${API_URL}/admins`
export const ADMIN_NOTIFICATIONS_URL = `${API_URL}/admin-notifications`
export const ADMINS_INVITES_URL = `${ADMINS_URL}/invites`
export const SETTINGS_URL = `${API_URL}/settings`
export const AVAILABILITY_VIEWERS_URL = `${SETTINGS_URL}/availability-viewer`
export const ROLES_URL = `${SETTINGS_URL}/roles`
export const PERMISSIONS_URL = `${SETTINGS_URL}/permissions`
export const WHATSAPP_BOT_SETTINGS_URL = `${API_URL}/whatsapp-bot-settings`
export const NOTIFICATION_CONTENTS_URL = `${SETTINGS_URL}/notification-contents`
export const MEMBERSHIP_DEMO_BOOKLET_URL = `${SETTINGS_URL}/membership/demo-booklet`
export const MEMBERSHIP_DEMO_TAB_PHOTO_URL = `${SETTINGS_URL}/membership/demo-tab-photo`
export const MEMBERSHIP_DEMO_TAB_TEXTS_URL = `${SETTINGS_URL}/membership/demo-tab-texts`
export const LOYALTY_TIERS_URL = `${API_URL}/loyalty-tiers`
export const MARKETING_URL = `${API_URL}/marketing`
export const AUDIENCES_URL = `${MARKETING_URL}/audiences`
export const AUDIENCES_PREVIEW_COUNT_URL = `${AUDIENCES_URL}/preview-count`
export const NOTIFICATIONS_URL = `${MARKETING_URL}/notifications`
export const SMART_BANNER_EMBED_SNIPPET_URL = `${MARKETING_URL}/smart-banner/embed-snippet`
export const TENANTS_URL = `${API_URL}/tenants`
export const RESERVATIONS_URL = `${API_URL}/reservations`
export const RESERVATION_STATUSES_URL = `${API_URL}/reservation-statuses`
export const ACTIVITY_LOGS_URL = `${API_URL}/activity-logs`
export const LEGAL_DOCUMENTS_URL = `${API_URL}/legal-documents`

/** ANALYTICS - Unified Analytics Endpoints */
export const ANALYTICS_STATISTICS_URL = `${API_URL}/analytics/statistics`
export const ANALYTICS_GRAPH_URL = `${API_URL}/analytics/graph`

/** INTEGRATIONS */
export const VENUE_INTEGRATIONS_URL = `${VENUES_URL}/integrations`
export const INTEGRATIONS_URL = `${API_URL}/integrations`
export const GLEAP_TICKETS_URL = `${INTEGRATIONS_URL}/gleap-tickets`
export const INTEGRATIONS_SEVENROOMS_AUDIENCE_URL = `${INTEGRATIONS_URL}/sevenrooms-audiences`
export const INTEGRATIONS_SEVENROOMS_VENUE_GROUP_URL = `${INTEGRATIONS_URL}/sevenrooms-venue-groups`
export const DOMINO_CONFIGS_URL = `${INTEGRATIONS_URL}/domino-configs`
export const INTEGRATIONS_ADYEN_CONFIGS_URL = `${INTEGRATIONS_URL}/adyen-configs`

/** MEMBERSHIP */
export const MEMBERSHIP_URL = `${API_URL}/membership`
export const MEMBERSHIP_PROGRAMS_URL = `${MEMBERSHIP_URL}/programs`
export const MEMBERSHIP_PROGRAM_CURRENCIES_URL = `${MEMBERSHIP_PROGRAMS_URL}/currencies`
export const MEMBERSHIP_SUBSCRIPTIONS_URL = `${MEMBERSHIP_URL}/subscriptions`
export const MEMBERSHIP_SUBSCRIPTION_PAYMENTS_URL = `${MEMBERSHIP_URL}/subscription-payments`
// Both analytics read-models hang off the resource they read (ticket 537): the
// transactions table is a SubscriptionPayment listing, the renewals table a
// Subscription one. Their KPI tiles are statistics kinds, not sub-paths here.
export const MEMBERSHIP_TRANSACTIONS_URL = `${MEMBERSHIP_SUBSCRIPTION_PAYMENTS_URL}/transactions`
export const MEMBERSHIP_INCOMING_RENEWALS_URL = `${MEMBERSHIP_SUBSCRIPTIONS_URL}/incoming-renewals`
export const MEMBERSHIP_SUBSCRIPTION_TAGS_URL = `${MEMBERSHIP_URL}/subscription-tags`
export const MEMBERSHIP_MEMBERSHIP_PROFILES_URL = `${MEMBERSHIP_URL}/membership-profiles`
export const MEMBERSHIP_MEMBERSHIP_PROFILE_CURRENCIES_URL = `${MEMBERSHIP_MEMBERSHIP_PROFILES_URL}/currencies`
export const MEMBERSHIP_FORM_QUESTIONS_URL = `${MEMBERSHIP_URL}/onboarding-form/items`
export const MEMBERSHIP_FORM_ANSWERS_URL = `${MEMBERSHIP_URL}/onboarding-form/answers`
export const MEMBERSHIP_FORM_QUESTION_OPTIONS_URL = `${MEMBERSHIP_URL}/onboarding-form/question-options`
export const MEMBERSHIP_PLANS_URL = `${MEMBERSHIP_URL}/plans`
export const MEMBERSHIP_PROFILES_URL = `${MEMBERSHIP_URL}/profiles`
export const MEMBERSHIP_PROFILE_TAGS_URL = `${MEMBERSHIP_URL}/membership-profile-tags`
export const COUPONS_URL = `${MEMBERSHIP_URL}/coupons`
export const EVENTS_URL = `${MEMBERSHIP_URL}/events`
export const PARTICIPATIONS_URL = `${MEMBERSHIP_URL}/event-participations`
export const PERKS_URL = `${MEMBERSHIP_URL}/perks`
export const PARTICIPATIONS_STATUSES_URL = `${API_URL}/event-participation-statuses`
export const EVENTS_COLLECTIONS_URL = `${MEMBERSHIP_URL}/event-collections`
export const MEMBERSHIP_PROGRAM_COMPLEMENTARY_ITEMS_URL = `${MEMBERSHIP_PROGRAMS_URL}/complementary-items`
export const MEMBERSHIP_PROFILE_COMPLEMENTARY_ITEMS_URL = `${MEMBERSHIP_MEMBERSHIP_PROFILES_URL}/complementary-items`

/** BUSINESS */
export const COMPANIES_URL = `${BUSINESS_URL}/companies`
export const COMPANY_CONTACTS_URL = `${BUSINESS_URL}/company-contacts`
export const COMPANY_STATUSES_URL = `${BUSINESS_URL}/company-statuses`
export const BUSINESS_PROFILE_STATUSES_URL = `${BUSINESS_URL}/business-profile-statuses`
export const POLICIES_URL = `${BUSINESS_URL}/policies`
export const BUSINESS_PROFILS_URL = `${BUSINESS_URL}/business-profiles`
export const BUSINESS_VERIFIERS_URL = `${BUSINESS_URL}/business-verifiers`
export const BUSINESS_COMPANY_STATUSES_URL = `${BUSINESS_URL}/categories`
export const RESERVATION_FINANCIALS_URL = `${BUSINESS_URL}/reservation-financials`
export const RESERVATION_EXPORT_URL = `${BUSINESS_URL}/reservation/export`
export const BUSINESS_RESERVATIONS_URL = `${BUSINESS_URL}/reservations`
export const SHIFTS_URL = `${BUSINESS_URL}/shifts`
export const DAYS_URL = `${BUSINESS_URL}/days`
export const BILLING_METHODS_URL = `${BUSINESS_URL}/billing-methods`

export const CURRENCIES_URL = `${API_URL}/currencies`

/** COMPLEMENTARY ITEMS */
export const COMPLEMENTARY_ITEMS_URL = `${API_URL}/complementary-items`

/** SETTINGS API **/
export const EXTERNAL_BOOKING_API_KEYS_URL = `${SETTINGS_URL}/apis/external-booking`

/** HELP CENTER — Gleap-hosted knowledge base (public, not the API).
 * Single place to swap when moving to a custom domain. */
export const HELP_CENTER_URL = 'https://dwqmhpops.gleap.help'
export const HELP_CENTER_ARTICLES_URL = `${HELP_CENTER_URL}/en`
export const HELP_CENTER_WHATSAPP_CONNECTION_URL = `${HELP_CENTER_ARTICLES_URL}/articles/18-connecting-a-whatsapp-profile-to-plethore#heading-1-2-manual-connection`

/** TESTS **/
export const TEST_COMMUNICATIONS_URL = `${API_URL}/communications`
export const TEST_USERS_URL = `${TEST_COMMUNICATIONS_URL}/test-users`
